<template>
  <v-layout>
    <v-flex hidden-xs-only text-md-right>
      <v-btn class="btn-primary-security-menu text-14-security" :class="active == 'Bienvenidos' ? 'btn-active-green white--text' : ''" to="celebremos-bienvenidos">Bienvenidos</v-btn>
      <v-btn class="btn-primary-security-menu text-14-security" :class="active == 'Cumpleaños' ? 'btn-active-green white--text' : ''" to="celebremos-cumpleanos">Cumpleaños</v-btn>
      <v-btn class="btn-primary-security-menu text-14-security" :class="active == 'Nacimientos' ? 'btn-active-green white--text' : ''" to="celebremos-nacimientos">Nacimientos</v-btn>
    </v-flex>
    <v-flex hidden-sm-and-up text-md-right>
      <v-btn small round class="caption-security" :class="active == 'Bienvenidos' ? 'btn-active-green white--text' : ''" to="celebremos-bienvenidos">Bienvenidos</v-btn>
      <v-btn small round class="caption-security" :class="active == 'Cumpleaños' ? 'btn-active-green white--text' : ''" to="celebremos-cumpleanos">Cumpleaños</v-btn>
      <v-btn small round class="caption-security" :class="active == 'Nacimientos' ? 'btn-active-green white--text' : ''" to="celebremos-nacimientos">Nacimientos</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    active: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
</style>